// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"Icon_iconWrapper__Z1dWw","iconBackground":"Icon_iconBackground__L5uJU","iconMainIcon":"Icon_iconMainIcon__wpacv"};